import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Entities } from '../../../../core/models/globals';
import { UserProcess } from '../../../../core/models/session';
import { UserRoleNames } from '../../../../core/models/users';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { HeaderService } from '../../../../core/services/header.service';
import { NavigationService } from '../../../../core/services/navigation.service';
import { SessionService } from '../../../../core/services/session.service';
import { NodeactionConfirmComponent } from '../../../node/modals/nodeaction-confirm/nodeaction-confirm.component';
import { ActionConfirmComponent } from '../action-confirm/action-confirm.component';

@Component({
  selector: 'app-session-processes',
  templateUrl: './session-processes.component.html',
  styleUrls: ['./session-processes.component.scss']
})
export class SessionProcessesComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private navService: NavigationService,
    private sessionService: SessionService,
    private headerService: HeaderService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }
  selectAll = false;
  selectedProcs = [];
  procs: UserProcess[];
  p: number = 1;
  available: boolean = false;
  currentEntity;
  filterText: string = "";
  filteredProcesses: UserProcess[];
  filterProcessState: string = 'All'; // filter
  multiSelectIndex = [];
  filtersApplied: boolean = false;
  showTrackUntrack: boolean = true;
  depNames: string[] = [];
  isMonitor: boolean = this.authenticationService.currentUserValue.role == UserRoleNames.Reader ? true : false;

  ngOnInit(): void {
    this.navService.breadcrumbEntity.subscribe((x) => { this.currentEntity = x; });
    this.navService.sendParentData('Processes');
    this.navService.sendLeftPanelIndex(1);
    this.showTrackUntrack = this.authenticationService.getRole() == UserRoleNames.JobOperator ? false : true;
    this.depNames = this.headerService.getQuickAccessDeploymentNames();
    this.loadProcesses();
  }

  loadProcesses() {
    this.sessionService
      .getAllProcesses().subscribe({
        next: (data) => {
          this.spinner.hide()
          if (data == null) {
            this.available = false;
            return;
          }
          this.procs = <UserProcess[]>JSON.parse(JSON.stringify(data));
          this.available = true;
        }, error: (err) => {
          this.spinner.hide();
          this.available = false;
        }
      });
    this.available = true;
  }

  onSelectAllCheckBox(event) {
    /*if (event.target.checked) {
      this.selectAll = true
      if (!this.procs) return;
      for (let i = 0; i < this.procs.length; i++) {
        if (!this.selectedProcs.includes(this.procs[i].processName)) {
          this.selectedProcs.push(this.procs[i].processName)
        }
      }
    } else {
      this.selectedProcs = []
      this.selectAll = false
    }*/

    let filteredProcesses = this.applyFilter();
    if (event.target.checked) {
      if (!this.procs) return;
      filteredProcesses.forEach((proc, i) => {
        if (!this.selectedProcs.includes(proc.processName)) {
          this.selectedProcs.push(proc.processName);
        }
      })
      if (filteredProcesses.length == this.procs.length) {
        this.selectAll = true;
      }
      else {
        this.selectAll = false;
      }
      return;
    }
    else {
      filteredProcesses.forEach((proc, i) => {
        if (this.selectedProcs.includes(proc.processName)) {
          let index = this.selectedProcs.indexOf(proc.processName);
          if (index !== -1) {
            this.selectedProcs.splice(index, 1);
          }
        }
      })
      if (filteredProcesses.length == this.procs.length) {
        this.selectAll = false;
      }
      return;
    }
  }

  applyFilter() {
    this.filtersApplied = true;
    this.filteredProcesses = this.procs;
    if (this.filterText != "") {
      this.filteredProcesses = this.filteredProcesses.filter(nd => nd.processName.toLowerCase().includes(this.filterText.toLowerCase()))
    }
    if (this.filterProcessState != 'All')
    {
      this.filteredProcesses = this.filteredProcesses.filter(nd => nd.isTracked == this.filterProcessState);
    }
    return this.filteredProcesses;
  }

  resetFilter() {
    this.filtersApplied = false;
    this.filterProcessState = 'All';
    this.filterText = "";
  }

  checkSelectedCheckboxes(event, procName) {
    if (event.target.checked) {
      if (!this.selectedProcs.includes(procName)) {
        this.selectedProcs.push(procName)
        if (this.selectedProcs.length == this.procs.length) {
          this.selectAll = true
        }
      }
    }
    else {
      let idx = this.selectedProcs.indexOf(procName)
      this.selectedProcs.splice(idx, 1)
      if (this.selectedProcs.length == 0 || this.selectedProcs.length != this.procs.length) {
        this.selectAll = false
      }
    }
  }

  makeTracked() {
    if (!this.depNames || this.depNames == null || this.depNames.length == 0) {
      this.snackBar.open("Since no deployment is attached, you can not track the processes.", "OK", { duration: 5000 });
      this.selectAll = false;
      this.selectedProcs = [];
      this.refreshComponent();
      return;
    }
    if (this.selectedProcs.length == 0) {
      this.snackBar.open("No process selected", "Ok", { duration: 5000 })
      return;
    };
    const dialog = this.dialog.open(ActionConfirmComponent, {
      disableClose: true,
      width: '400px',
      data: {
        message: 'Do you want to Track selected applications ?',
      },
    })

    dialog.afterClosed().subscribe(res => {
      if (res) {
        if (this.selectAll == true) {
          this.snackBar.open("Processes are being added to tracking list, Please Wait", "Ok", { duration: 5000 })
        }
        this.spinner.show();
        this.sessionService.addTrackedApplications(this.selectedProcs, 'true')
          .subscribe({
            next: (data: any) => {
              if (this.selectAll) this.selectAll = false;
              this.selectedProcs = []
              this.loadProcesses();
              this.snackBar.open(data.actionMessage || "Applications are added into tracking list.", "Ok", {
                duration: 5000
              })
              this.selectAll = false;
              this.spinner.hide();
              this.refreshComponent();
            },
            error: (err) => {
              this.snackBar.open(err.error.actionMessage), "Ok", {
                duration: 5000
              }
              this.selectAll = false;
              this.spinner.hide();
              this.refreshComponent();
            }
          })
      }
    })
  }

  makeUntracked() {
    if (!this.depNames || this.depNames == null || this.depNames.length == 0) {
      this.snackBar.open("Since no deployment is attached, you can not untrack the processes.", "OK", { duration: 5000 });
      this.selectAll = false;
      this.selectedProcs = [];
      this.refreshComponent();
      return;
    }
    if (this.selectedProcs.length == 0) {
      this.snackBar.open("No process selected", "Ok", { duration: 5000 })
      return;
    };
    const dialog = this.dialog.open(ActionConfirmComponent, {
      disableClose: true,
      width: '400px',
      data: {
        message: 'Do you want to Remove Selected Applications from Tracking ?',
      },
    })

    dialog.afterClosed().subscribe(res => {
      if (res) {
        if (this.selectAll == true) {
          this.snackBar.open("Processes are being removed from tracking list, Please Wait", "Ok", { duration: 5000 })
        }
        this.spinner.show();
        this.sessionService.addTrackedApplications(this.selectedProcs, 'false')
          .subscribe({
            next: (data: any) => {
              if (this.selectAll) this.selectAll = false;
              this.selectedProcs = []
              this.loadProcesses();
              this.snackBar.open(data.actionMessage || "Applcations are removed from tracking list.", "Ok", {
                duration: 5000
              })
              this.selectAll = false;
              this.spinner.hide();
              this.refreshComponent();
            },
            error: (err) => {
              this.snackBar.open(err.error.actionMessage), "Ok", {
                duration: 5000
              }
              this.selectAll = false;
              this.spinner.hide();
              this.refreshComponent();
            }
          })
      }
    })
  }


  onSearch() {
    this.filteredProcesses = this.procs
    if (this.filterText != "") {
      this.filteredProcesses = this.filteredProcesses.filter(nd => nd.processName.toLowerCase().includes(this.filterText.toLowerCase()))
    }
    this.p = 1;
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
